import {Types} from "../actions/quizActions";
import _ from "lodash";
import ReactPixel from 'react-facebook-pixel';

import cleanDeep from 'clean-deep';

const quizReducers = (state, action) => {
  switch (action.type) {
    case Types.QUIZ_ANSWER: {
      console.log('quizReducer',action)
      let newState = {...state}

      if (!newState.quiz){
        newState.quiz = {
          index: 0,
          answers: [],
          questions: [],
          filter: {}
        }
      }

      newState.quiz.index = action.questionIndex + 1

      newState.quiz.questions[action.questionIndex] = action.question

      if (typeof(action.answer) == 'string'){
        newState.quiz.answers[action.questionIndex] = action.answer
      } else {
        newState.quiz.answers[action.questionIndex] = action.answer.value
        newState.quiz.filter = {
          ...newState.quiz.filter,
          ...action.answer.setFilter
        }
      }

      return newState;
    }
    case Types.QUIZ_INDEX: {
      console.log('quizReducer',action)
      let newState = {...state}

      newState.quiz.index = action.index

      return newState;
    }

    default:
      return state;
  }
};

export default quizReducers;